export const templates = {
  // Solar

  'cleaning-and-technical-maintenance': [
    {
      title: 'Is your solar setup for residential or commercial use?',
      name: 'solar-power-system',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'How are your solar panels installed?',
      name: 'install-method',
      options: [
        { img: 'roof-mounted', value: 'Roof Mounted' },
        { img: 'ground-mounted', value: 'Ground Mounted' },
        { img: 'wall-mounted', value: 'Wall Mounted' },
      ],
    },
    {
      title: 'How often do you want your panels to be cleaned?',
      name: 'cleaning-frequency',
      options: [
        { img: 'one-time', value: 'One time' },
        { img: 'monthly', value: 'Monthly' },
        { img: 'quarterly', value: 'Quarterly' },
      ],
    },
    {
      title: 'How many solar panels do you have?',
      name: 'panels-count',
      min: 1,
      max: 100,
      isKeepGoing: true,
    },
  ],

  'installation-of-solar-panels': [
    {
      title: 'Is your solar setup for residential or commercial use?',
      name: 'solar-system',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What type of solar power system do you need?',
      name: 'system-type',
      options: [
        { img: 'grid-tied', value: 'Grid-tied solar system' },
        { img: 'off-grid', value: 'Off-grid solar system' },
        { img: 'hybrid', value: 'Hybrid solar system' },
        { img: 'need-consultation', value: 'I need a consultation' },
      ],
    },
    {
      title: 'What installation method do you prefer?',
      name: 'install-method',
      options: [
        { img: 'roof-mounted', value: 'Roof Mounted' },
        { img: 'ground-mounted', value: 'Ground Mounted' },
        { img: 'wall-mounted', value: 'Wall Mounted' },
      ],
    },
    {
      title: 'Do you have the required equipment?',
      name: 'have-equipment',
      options: [
        { img: 'components-one', value: 'Yes, I have the equipment' },
        { img: 'components-two', value: 'No, I need to buy equipment' },
      ],
      isKeepGoing: true,
    },
  ],

  'repair-of-solar-panels': [
    {
      title: 'Is your solar setup for residential or commercial use?',
      name: 'solar-system',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'How are your solar panels installed?',
      name: 'install-method',
      options: [
        { img: 'roof-mounted', value: 'Roof Mounted' },
        { img: 'ground-mounted', value: 'Ground Mounted' },
        { img: 'wall-mounted', value: 'Wall Mounted' },
      ],
      isColumn: true,
    },
    {
      title: 'Briefly describe the issue',
      name: 'damage-description',
      label: 'Describe the damage',
      isTextarea: true,
      skip: true,
      isKeepGoing: true,
    },
  ],

  'solar-panels-maintenance': [
    {
      title: 'Is your solar setup for residential or commercial use?',
      name: 'solar-power-system',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'How are your solar panels installed?',
      name: 'install-method',
      options: [
        { img: 'roof-mounted', value: 'Roof Mounted' },
        { img: 'ground-mounted', value: 'Ground Mounted' },
        { img: 'wall-mounted', value: 'Wall Mounted' },
      ],
    },
    {
      title: 'What type of maintenance service do you need?',
      subtitle: 'Multiple selection is available',
      name: 'maintenance-service-type',
      options: [
        { img: 'inspection_cleaning', value: 'Regular inspection and cleaning' },
        { img: 'monitoring', value: 'Performance monitoring and testing' },
        { img: 'inverter', value: 'Inverter maintenance' },
        { img: 'outlets', value: 'Electrical connection check' },
        { img: 'repairs', value: 'Panel replacement or repair' },
        { img: 'optimization', value: 'System optimization' },
      ],
      multiple: true,
      withOther: true,
    },
    {
      title: 'How often would you like maintenance service?',
      name: 'maintenance-frequency',
      options: [
        { img: 'one-time', value: 'One time' },
        { img: 'monthly', value: 'Monthly' },
        { img: 'quarterly', value: 'Quarterly' },
      ],
      isColumn: true,
      withOther: true,
      isKeepGoing: true,
    },
  ],

  'solar-system-design': [
    {
      title: 'Is your solar setup for residential or commercial use?',
      name: 'solar-power-system',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What type of solar power system do you need?',
      name: 'system-type',
      options: [
        { img: 'grid-tied', value: 'Grid-tied solar system' },
        { img: 'off-grid', value: 'Off-grid solar system' },
        { img: 'hybrid', value: 'Hybrid solar system' },
        { img: 'need-consultation', value: 'I need a consultation' },
      ],
    },
    {
      title: 'What is your primary goal for solar energy?',
      subtitle: 'Multiple selection is available',
      name: 'solar-goals',
      options: [
        { img: 'reducing_bills', value: 'Reduce electricity bills' },
        { img: 'backup_power_2', value: 'Backup power during outages' },
        { img: 'independence', value: 'Complete energy independence' },
        { img: 'environmental_sustainability', value: 'Environmental benefits' },
        { img: 'increase_value', value: 'Increase property value' },
        { img: 'specific_equipment', value: 'Power specific equipment (pool, EV, etc.)' },
      ],
      multiple: true,
      withOther: true,
    },
    {
      title: 'What installation method do you prefer?',
      name: 'install-method',
      options: [
        { img: 'roof-mounted', value: 'Roof Mounted' },
        { img: 'ground-mounted', value: 'Ground Mounted' },
        { img: 'wall-mounted', value: 'Wall Mounted' },
        { img: 'need-consultation', value: 'Need consultation' },
      ],
      isKeepGoing: true,
    },
  ],

  'solar-system-repair': [
    {
      title: 'Is your solar setup for residential or commercial use?',
      name: 'solar-system',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What type of solar system do you have?',
      name: 'system-type',
      options: [
        { img: 'grid-tied', value: 'Grid-tied solar system' },
        { img: 'off-grid', value: 'Off-grid solar system' },
        { img: 'hybrid', value: 'Hybrid solar system' },
      ],
    },
    {
      title: 'Briefly describe the issue',
      name: 'damage-description',
      label: 'Describe the issue',
      isTextarea: true,
      skip: true,
    },
    {
      title: 'Have you already received an estimate?',
      name: 'estimate-received',
      options: [
        { img: 'yes', value: 'Yes' },
        { img: 'no', value: 'No' },
        { img: 'not_sure', value: 'Not sure' },
      ],
      isKeepGoing: true,
    },
  ],

  // Roofing

  'roof-repair': [
    {
      title: 'What type of property do you have?',
      name: 'project-type',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What kind of roofing work do you need?',
      name: 'roofing-work',
      options: [
        { img: 'roof-replace', value: 'Replace or retile the roof' },
        { img: 'repair-existing', value: 'Repair the existing roof' },
        { img: 'new-roof', value: 'New building construction' },
      ],
    },
    {
      title: 'What type of roof do you have (or prefer)?',
      name: 'roof-material',
      options: [
        { img: 'asphalt-shingle', value: 'Asphalt shingle' },
        { img: 'metal', value: 'Metal' },
        { img: 'flat-roof', value: 'Flat roof' },
        { img: 'tile', value: 'Tile' },
        { img: 'question', value: 'Not sure' },
      ],
      withOther: true,
    },
    {
      title: 'How big is your house?',
      name: 'house-area',
      min: 1,
      max: 10000,
      unit: 'sq.ft.',
      isKeepGoing: true,
    },
  ],

  'roof-inspection': [
    {
      title: 'What type of roof do you have?',
      name: 'roof-type',
      options: [
        { img: 'asphalt-shingle', value: 'Asphalt shingle' },
        { img: 'metal', value: 'Metal' },
        { img: 'flat-roof', value: 'Flat roof' },
        { img: 'tile', value: 'Tile' },
        { img: 'question', value: 'Not sure' },
      ],
      withOther: true,
    },
    {
      title: 'What is the approximate size of your roof?',
      name: 'roof-size',
      min: 100,
      max: 50000,
      unit: 'sq.ft.',
    },
    {
      title: 'What issues are you concerned about?',
      name: 'concerned-issues',
      options: [
        { img: 'water', value: 'Leaks or water damage' },
        { img: 'damaged-tiles', value: 'Missing or damaged shingles/tiles' },
        { img: 'growth', value: 'Mold, algae, or moss growth' },
        { img: 'sagging', value: 'Sagging or structural issues' },
      ],
      withOther: true,
    },
    {
      title: 'What type of inspection do you need?',
      name: 'inspection-type',
      options: [
        { img: 'inspection', value: 'Standard inspection' },
        { img: 'detailed', value: 'Detailed assessment' },
      ],
      isKeepGoing: true,
    },
  ],

  'roof-cleaning': [
    {
      title: 'What type of roof do you have?',
      name: 'roof-type',
      options: [
        { img: 'asphalt-shingle', value: 'Asphalt shingle' },
        { img: 'metal', value: 'Metal' },
        { img: 'flat-roof', value: 'Flat roof' },
        { img: 'tile', value: 'Tile' },
        { img: 'question', value: 'Not sure' },
      ],
      withOther: true,
    },
    {
      title: 'What do you need to remove from your roof?',
      name: 'need-remove',
      options: [
        { img: 'moss', value: 'Moss' },
        { img: 'growth', value: 'Mold' },
        { img: 'debris', value: 'Debris' },
        { img: 'leaves', value: 'Leaves' },
        { img: 'ice', value: 'Ice' },
      ],
      withOther: true,
    },
    {
      title: 'Do you have access to water and electricity on site?',
      name: 'utility-access',
      options: [
        { img: 'yes', value: 'Yes' },
        { img: 'no', value: 'No' },
        { img: 'water', value: 'Only water' },
        { img: 'electricity', value: 'Only electricity' },
      ],
    },
    {
      title: 'Do you need gutter cleaning?',
      name: 'gutter-cleaning-needed',
      options: [
        { img: 'gutter-yes', value: 'Yes' },
        { img: 'gutter-no', value: 'No' },
      ],
      isKeepGoing: true,
    },
  ],

  'roof-snow-removal': [
    {
      title: 'What type of roof do you have?',
      name: 'roof-type',
      options: [
        { img: 'asphalt-shingle', value: 'Asphalt shingle' },
        { img: 'metal', value: 'Metal' },
        { img: 'flat-roof', value: 'Flat roof' },
        { img: 'tile', value: 'Tile' },
      ],
      withOther: true,
    },
    {
      title: 'How much snow and ice is on your roof?',
      name: 'ice-layers',
      options: [
        { img: 'little-snow', value: 'A little snow, no ice' },
        { img: 'some-snow', value: 'Some snow and ice buildup' },
        { img: 'big-snow', value: 'A lot of snow and thick ice layers' },
        { img: 'detailed', value: 'Not sure – need an inspection' },
      ],
    },
    {
      title: 'Do you need to remove icicles and ice buildup from the edges?',
      name: 'icicle-cleanup-needed',
      options: [
        { img: 'icicle-yes', value: 'Yes' },
        { img: 'icicle-no', value: 'No' },
      ],
    },
    {
      title: 'Is there easy access to the roof, or will special equipment be required?',
      name: 'roof-access',
      options: [
        { img: 'no-equipment', value: 'Easy access – no special equipment needed' },
        { img: 'some-equipment', value: 'Limited access – some equipment may be needed' },
        { img: 'special-equipment', value: 'Difficult access – special equipment required' },
        { img: 'detailed', value: 'Not sure – need assessment' },
      ],
      isKeepGoing: true,
    },
  ],

  'roof-maintenance': [
    {
      title: 'What type of roof do you have?',
      name: 'roof-material',
      options: [
        { img: 'asphalt-shingle', value: 'Asphalt shingle' },
        { img: 'metal', value: 'Metal' },
        { img: 'flat-roof', value: 'Flat roof' },
        { img: 'tile', value: 'Tile' },
      ],
      withOther: true,
    },
    {
      title: 'When was the last maintenance performed?',
      name: 'last-maintenance',
      options: [
        { value: 'Less than a year ago' },
        { value: '1-3 years ago' },
        { value: 'More than 3 years ago' },
        { value: 'Never' },
        { value: 'Not sure' },
      ],
      isColumn: true,
    },
    {
      title: 'What services do you need?',
      name: 'services',
      options: [
        { img: 'cleaning', value: 'Cleaning' },
        { img: 'sealing', value: 'Sealing' },
        { img: 'paint', value: 'Paint' },
        { img: 'repairs', value: 'Repairs' },
      ],
      withOther: true,
    },
    {
      title: 'Are you looking for a one-time service or regular maintenance?',
      name: 'service-frequency',
      options: [
        { img: 'one', value: 'One-time service' },
        { img: 'regular', value: 'Regular maintenance' },
      ],
      isKeepGoing: true,
    },
  ],

  'roof-installation': [
    {
      title: 'What type of roof do you plan to install?',
      name: 'preferred-material',
      options: [
        { img: 'asphalt-shingle', value: 'Asphalt shingle' },
        { img: 'metal', value: 'Metal' },
        { img: 'flat-roof', value: 'Flat roof' },
        { img: 'tile', value: 'Tile' },
        { img: 'question', value: 'Have not decided yet' },
      ],
      withOther: true,
    },
    {
      title: 'What is the size of your roof?',
      name: 'roof-size',
      min: 100,
      max: 50000,
      unit: 'sq.ft.',
    },
    {
      title: 'Is this a new construction or a replacement?',
      name: 'new-or-replacement',
      options: [
        { img: 'new', value: 'New construction' },
        { img: 'full-replacement', value: 'Full roof replacement' },
        { img: 'partial-replacement', value: 'Partial roof replacement' },
        { img: 'need-consultation', value: 'Consultation needed' },
      ],
    },
    {
      title: 'When do you want to start?',
      name: 'preferred-start-time',
      options: [
        { value: 'As soon as possible' },
        { value: 'Not sure – consultation needed' },
      ],
      withOther: true,
      isColumn: true,
      isKeepGoing: true,
    },
  ],

  'roof-replacement': [
    {
      title: 'What type of roof do you currently have?',
      name: 'current-material',
      options: [
        { img: 'asphalt-shingle', value: 'Asphalt shingle' },
        { img: 'metal', value: 'Metal' },
        { img: 'flat-roof', value: 'Flat roof' },
        { img: 'tile', value: 'Tile' },
      ],
      withOther: true,
    },
    {
      title: 'What material do you want for the new roof?',
      name: 'preferred-material',
      options: [
        { img: 'asphalt-shingle', value: 'Asphalt shingle' },
        { img: 'metal', value: 'Metal' },
        { img: 'flat-roof', value: 'Flat roof' },
        { img: 'tile', value: 'Tile' },
        { img: 'question', value: 'Not sure' },
      ],
      withOther: true,
    },
    {
      title: 'Do you need to remove your old roof?',
      name: 'old-roof-removal-needed',
      options: [
        { img: 'full-removal', value: 'Yes, full removal' },
        { img: 'partial-removal', value: 'Partial removal' },
        { img: 'install-over', value: 'No, install over existing' },
        { img: 'need-consultation', value: 'Consultation required' },
      ],
    },
    {
      title: 'Are there any issues that need to be addressed before replacement?',
      name: 'existing-problems-known',
      options: [
        { img: 'water', value: 'Yes, leaks or water damage' },
        { img: 'sagging', value: 'Yes, structural issues' },
        { img: 'fine', value: 'No, everything is fine' },
        { img: 'detailed', value: 'Inspection required' },
      ],
      isKeepGoing: true,
    },
  ],

  // Engineering

  'home-inspection': [
    {
      title: 'What type of property do you need inspected?',
      name: 'property-type',
      options: [
        { img: 'panels-no', value: 'House' },
        { img: 'apartment', value: 'Apartment' },
        { img: 'condo', value: 'Condo' },
        { img: 'townhouse', value: 'Townhouse' },
        { img: 'commercial', value: 'Commercial property' },
      ],
      withOther: true,
    },
    {
      title: 'What is the reason for the inspection?',
      name: 'inspection-reason',
      options: [
        { img: 'buying_selling', value: 'Buying/selling a home' },
        { img: 'annual_maintenance_check', value: 'Annual maintenance check' },
        { img: 'insurance', value: 'Insurance requirements' },
        { img: 'suspected_damage', value: 'Suspected issues or problems' },
        { img: 'pre-renovation', value: 'Pre-renovation assessment' },
      ],
      withOther: true,
    },
    {
      title: 'What type of inspection do you need?',
      subtitle: 'Multiple selection is available',
      name: 'inspection-type',
      options: [
        { img: 'home', value: 'General home inspection' },
        { img: 'electrical', value: 'Electrical system inspection' },
        { img: 'plumbing', value: 'Plumbing inspection' },
        { img: 'hvac', value: 'HVAC system inspection' },
        { img: 'roof', value: 'Roof inspection' },
        { img: 'foundation', value: 'Foundation inspection' },
        { img: 'pest', value: 'Pest inspection' },
        { img: 'mold', value: 'Mold inspection' },
        { img: 'radon', value: 'Radon testing' },
        { img: 'lead_paint', value: 'Lead paint testing' },
      ],
      multiple: true,
      withOther: true,
    },
    {
      title: 'How big is your home?',
      name: 'home-size',
      min: 1,
      max: 15000,
      unit: 'sq.ft.',
      isKeepGoing: true,
    },
  ],

  'home-energy-audit': [
    {
      title: 'What type of property do you have?',
      name: 'property-type',
      options: [
        { img: 'panels-no', value: 'House' },
        { img: 'apartment', value: 'Apartment' },
        { img: 'condo', value: 'Condo' },
        { img: 'townhouse', value: 'Townhouse' },
      ],
      withOther: true,
    },
    {
      title: 'What aspects of your home would you like to assess?',
      subtitle: 'Multiple selection is available',
      name: 'aspects-to-assess',
      options: [
        { img: 'central_conditioning', value: 'Insulation and air leaks' },
        { img: 'water_heating', value: 'Water heating efficiency' },
        { img: 'hvac', value: 'HVAC system efficiency' },
        { img: 'solar_potential', value: 'Solar energy potential' },
        { img: 'lighting_energy', value: 'Lighting and appliance energy use' },
        { img: 'home_monitoring', value: 'Whole-home energy monitoring' },
      ],
      multiple: true,
      withOther: true,
    },
    {
      title: 'How big is your home?',
      name: 'home-size',
      min: 1,
      max: 15000,
      unit: 'sq.ft.',
    },
    {
      title: 'What is your average monthly energy bill?',
      name: 'monthly-energy-bill',
      isInput: true,
      unit: '$',
      placeholder: 'Estimate in $ if possible',
      isKeepGoing: true,
    },
  ],

  'general-contractor': [
    {
      title: 'What type of property do you have?',
      name: 'property-type',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What type of construction project do you need?',
      name: 'project-type',
      options: [
        { img: 'new_construction', value: 'New construction' },
        { img: 'major_renovation', value: 'Major renovation' },
        { img: 'home_addition', value: 'Home addition' },
        { img: 'repairs', value: 'Repairs and maintenance' },
        { img: 'need-consultation', value: 'Need consultation' },
      ],
    },
    {
      title: 'What specific work do you need done?',
      subtitle: 'Multiple selection is available',
      name: 'work-needed',
      options: [
        { img: 'foundation', value: 'Foundation work' },
        { img: 'framing_structural', value: 'Framing and structural work' },
        { img: 'plumbing', value: 'Plumbing' },
        { img: 'flooring', value: 'Flooring' },
        { img: 'interior_finishing', value: 'Interior finishing' },
        { img: 'exterior_work', value: 'Exterior work (siding, windows)' },
        { img: 'regulatory_requirements', value: 'Complete project management' },
      ],
      multiple: true,
      withOther: true,
    },
    {
      title: 'What stage is your project currently in?',
      name: 'project-stage',
      options: [
        { img: 'drafting', value: 'Initial planning - need full design' },
        { img: 'regulatory_requirements', value: 'Have plans/permits ready' },
        { img: 'major_renovation', value: 'Partially started, need completion' },
        { img: 'start_construction', value: 'Ready to start construction' },
        { img: 'consultation', value: 'Need consultation to determine' },
      ],
      isKeepGoing: true,
    },
  ],

  'structural-engineering-services': [
    {
      title: 'What is the main reason behind your request?',
      name: 'reason-for-request',
      options: [
        { img: 'new_construction', value: 'New construction' },
        { img: 'renovation', value: 'Renovation' },
        { img: 'code_compliance', value: 'Code compliance' },
        { img: 'suspected_damage', value: 'Suspected damage' },
        { img: 'drafting', value: 'Plans review or drafting' },
      ],
      withOther: true,
    },
    {
      title: 'What is your estimated project timeline?',
      name: 'estimated-timeline',
      options: [
        { img: 'asap', value: 'ASAP' },
        { img: 'month', value: 'Within a month' },
        { img: 'flexible', value: 'Flexible' },
      ],
      isColumn: true,
      isKeepGoing: true,
    },
  ],

  'renewable-energy-consulting': [
    {
      title: 'What type of property do you have?',
      name: 'property-type',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What renewable energy solutions are you interested in?',
      subtitle: 'Multiple selection is available',
      name: 'renewable-solutions',
      options: [
        { img: 'solar_potential', value: 'Solar energy systems' },
        { img: 'wind_systems', value: 'Wind energy systems' },
        { img: 'energy_solutions', value: 'Energy storage solutions' },
        { img: 'geothermal_systems', value: 'Geothermal systems' },
        { img: 'water', value: 'Hydroelectric systems' },
        { img: 'hybrid_systems', value: 'Hybrid renewable systems' },
        { img: 'not_sure', value: 'Not sure - need guidance' },
      ],
      multiple: true,
      withOther: true,
    },
    {
      title: 'What is the main goal of your renewable energy project?',
      subtitle: 'Multiple selection is available',
      name: 'project-goals',
      options: [
        { img: 'reducing_bills', value: 'Reduce energy costs' },
        { img: 'independence', value: 'Achieve energy independence' },
        { img: 'environmental_sustainability', value: 'Environmental sustainability' },
        { img: 'regulatory_requirements', value: 'Meet regulatory requirements' },
      ],
      multiple: true,
      withOther: true,
    },
    {
      title: 'What stage is your project currently in?',
      name: 'project-stage',
      options: [
        { img: 'research', value: 'Initial research and exploration' },
        { img: 'site_assessment', value: 'Site assessment needed' },
        { img: 'feasibility_study', value: 'Feasibility study required' },
        { img: 'drafting', value: 'System design and planning' },
        { img: 'implementation', value: 'Ready for implementation' },
        { img: 'optimization', value: 'Existing system optimization' },
      ],
      isKeepGoing: true,
    },
  ],

  // Electrical

  'general-electric-services': [
    {
      title: 'What type of electrical work do you need?',
      subtitle: 'Multiple selection is available',
      name: 'work-type',
      options: [
        { value: 'Electrical repairs' },
        { value: 'Outdoor electrical work' },
        { value: 'New installations (lighting, outlets, appliances, etc.)' },
        { value: 'New construction work' },
        { value: 'Want to talk to electrician' },
      ],
      multiple: true,
      isColumn: true,
      withOther: true,
    },
    {
      title: 'What type of property do you have?',
      name: 'property-type',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What is your preferred timeline for installation?',
      name: 'preferred-start-time',
      options: [
        { img: 'asap', value: 'ASAP' },
        { img: 'week', value: 'Within a week' },
        { img: 'month', value: 'Within a month' },
        { img: 'flexible', value: 'Flexible' },
      ],
      isKeepGoing: true,
    },
  ],

  'lighting-services': [
    {
      title: 'What type of property do you have?',
      name: 'property-type',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What type of lighting service do you need?',
      subtitle: 'Multiple selection is available',
      name: 'lighting-service-type',
      options: [
        { img: 'indoor_lighting', value: 'New indoor lighting installation' },
        { img: 'outdoor_lighting', value: 'Outdoor or landscape light work' },
        { img: 'existing_lights', value: 'Replacing or upgrading existing lights' },
        { img: 'smart_lighting', value: 'Smart lighting system setup' },
        { img: 'repairs', value: 'Light repair' },
      ],
      multiple: true,
      withOther: true,
    },
    {
      title: 'Do you have the wiring for the new lighting?',
      name: 'have-wiring-for-lighting',
      options: [
        { img: 'wiring-yes', value: 'Yes' },
        { img: 'wiring-no', value: 'No' },
        { img: 'question', value: 'Not sure' },
        { img: 'none-needed', value: 'None needed' },
      ],
    },
    {
      title: 'What is your preferred timeline for installation?',
      name: 'preferred-start-time',
      options: [
        { img: 'asap', value: 'ASAP' },
        { img: 'week', value: 'Within a week' },
        { img: 'month', value: 'Within a month' },
        { img: 'flexible', value: 'Flexible' },
      ],
      isKeepGoing: true,
    },
  ],

  'electrical-system-upgrade': [
    {
      title: 'What type of property do you have?',
      name: 'property-type',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What type of electrical upgrade do you need?',
      subtitle: 'Multiple selection is available',
      name: 'upgrade-type',
      options: [
        { value: 'Electrical panel upgrade' },
        { value: 'Add new circuits' },
        { value: 'Upgrade wiring throughout property' },
        { value: 'GFCI/AFCI protection upgrade' },
        { value: 'Grounding system upgrade' },
      ],
      multiple: true,
      isColumn: true,
      withOther: true,
    },
    {
      title: 'What is driving the need for this upgrade?',
      subtitle: 'Multiple selection is available',
      name: 'upgrade-reason',
      options: [
        { img: 'charging_station', value: 'Adding EV charging station' },
        { img: 'solar_potential', value: 'Installing solar panels' },
        { img: 'new_appliances', value: 'Adding new appliances (AC, pool, etc.)' },
        { img: 'safety_concerns', value: 'Safety concerns' },
        { img: 'requirements', value: 'Code compliance requirements' },
      ],
      multiple: true,
      withOther: true,
    },
    {
      title: 'Are you experiencing any current electrical issues?',
      subtitle: 'Multiple selection is available',
      name: 'current-issues',
      options: [
        { img: 'trips', value: 'Frequent breaker trips' },
        { img: 'flickering_lights', value: 'Flickering lights' },
        { img: 'outlets', value: 'Outlets not working' },
        { img: 'burning_smell', value: 'Burning smell from panel' },
        { img: 'no_major_issues', value: 'No major issues currently' },
      ],
      multiple: true,
      withOther: true,
      isKeepGoing: true,
    },
  ],

  'charging-station-installation': [
    {
      title: 'What kind of property do you have?',
      name: 'property-kind',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'Where do you plan to install the charger?',
      name: 'charger-location',
      options: [
        { img: 'garage', value: 'Garage' },
        { img: 'driveway', value: 'Driveway' },
        { img: 'carport', value: 'Carport' },
        { img: 'consultation', value: 'Consultation needed' },
        { img: 'other', value: 'Other' },
      ],
    },
    {
      title: 'Do you have a preferred installation timeframe?',
      name: 'preferred-start-time',
      options: [
        { img: 'asap', value: 'ASAP' },
        { img: 'month', value: 'Within a month' },
        { img: 'flexible', value: 'Flexible' },
      ],
      isColumn: true,
      isKeepGoing: true,
    },
  ],

  'charging-station-repair': [
    {
      title: 'What kind of property do you have?',
      name: 'property-kind',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What type of charging station needs repair?',
      name: 'charger-type',
      options: [
        { img: 'outlets', value: 'Level 1 (120V standard outlet)' },
        { img: 'charging_station_2', value: 'Level 2 (240V home/workplace charger)' },
        { img: 'charging_station', value: 'DC fast charger (commercial)' },
        { img: 'supercharger', value: 'Tesla Supercharger/Destination Charger' },
        { img: 'not_sure', value: 'Not sure' },
      ],
    },
    {
      title: 'What issues are you experiencing?',
      subtitle: 'Multiple selection is available',
      name: 'repair-issues',
      options: [
        { img: 'charger_not', value: 'Charger not turning on' },
        { img: 'charging_stops', value: 'Charging stops unexpectedly' },
        { img: 'slow_charging', value: 'Slow charging speed' },
        { img: 'physical_damage', value: 'Physical damage to unit' },
        { img: 'network_issues', value: 'Network/app connectivity issues' },
        { img: 'error_appearing', value: 'Error codes appearing' },
      ],
      multiple: true,
      withOther: true,
    },
    {
      title: 'Where is your charging station located?',
      name: 'charger-location',
      options: [
        { img: 'garage', value: 'Garage' },
        { img: 'driveway', value: 'Driveway' },
        { img: 'carport', value: 'Carport' },
        { img: 'parking', value: 'Parking lot' },
        { img: 'outdoor', value: 'Wall-mounted outdoor' },
      ],
      withOther: true,
      isKeepGoing: true,
    },
  ],

  'generator-installation': [
    {
      title: 'What type of property do you have?',
      name: 'property-type',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What type of generator do you need?',
      name: 'generator-type',
      options: [
        { img: 'standby_generator', value: 'Standby (whole house backup)' },
        { img: 'portable_generator', value: 'Portable generator' },
        { img: 'inverter_generator', value: 'Inverter generator' },
        { img: 'consultation', value: 'Need consultation' },
      ],
    },
    {
      title: 'What is your primary reason for getting a generator?',
      subtitle: 'Multiple selection is available',
      name: 'generator-purpose',
      options: [
        { img: 'frequent', value: 'Frequent power outages in area' },
        { img: 'medical', value: 'Medical equipment dependency' },
        { img: 'whole_house_power', value: 'Whole house backup power' },
        { img: 'preparedness', value: 'Emergency preparedness' },
      ],
      multiple: true,
      withOther: true,
    },
    {
      title: 'What size generator do you think you need?',
      name: 'generator-size',
      options: [
        { value: 'Small (5-10 kW) - essentials only' },
        { value: 'Medium (10-20 kW) - most appliances' },
        { value: 'Large (20-30 kW) - whole house' },
        { value: 'Extra large (30+ kW) - large home/commercial' },
        { value: 'Need consultation to determine' },
      ],
      isColumn: true,
      isKeepGoing: true,
    },
  ],

  'generator-repair': [
    {
      title: 'What type of property do you have?',
      name: 'property-type',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What type of generator needs repair?',
      name: 'generator-type',
      options: [
        { img: 'standby_generator', value: 'Standby generator (whole house)' },
        { img: 'portable_generator', value: 'Portable generator' },
        { img: 'inverter_generator', value: 'Inverter generator' },
        { img: 'commercial_generator', value: 'Commercial/industrial generator' },
        { img: 'not_sure', value: 'Not sure' },
      ],
      withOther: true,
    },
    {
      title: 'What fuel type does your generator use?',
      name: 'fuel-type',
      options: [
        { value: 'Natural gas' },
        { value: 'Propane (LP)' },
        { value: 'Diesel' },
        { value: 'Gasoline' },
        { value: 'Not sure' },
      ],
      isColumn: true,
    },
    {
      title: 'What issues are you experiencing?',
      subtitle: 'Multiple selection is available',
      name: 'generator-issues',
      options: [
        { value: "Generator won't start" },
        { value: 'Generator starts but shuts down quickly' },
        { value: 'Strange noises or vibrations' },
        { value: 'Fuel leak' },
        { value: 'Electrical issues' },
        { value: 'Maintenance overdue' },
      ],
      multiple: true,
      isColumn: true,
      withOther: true,
      isKeepGoing: true,
    },
  ],

  'home-battery-installation': [
    {
      title: 'What kind of property do you have?',
      name: 'property-kind',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'Is your house connected to the grid?',
      name: 'grid-connection',
      options: [
        { img: 'connection-yes', value: 'Yes' },
        { img: 'connection-no', value: 'No' },
      ],
    },
    {
      title: 'What do you need a battery for?',
      subtitle: 'Multiple selection is available',
      name: 'battery-reason',
      options: [
        { img: 'backup_power', value: 'Backup power' },
        { img: 'reducing_bills', value: 'Reducing electricity bills' },
        { img: 'independence', value: 'Energy independence' },
        { img: 'other', value: 'Other' },
      ],
      multiple: true,
    },
    {
      title: 'Do you have solar panels installed?',
      name: 'solar-panels-installed',
      options: [
        { img: 'panels-yes', value: 'Yes' },
        { img: 'panels-no', value: 'No' },
      ],
      isKeepGoing: true,
    },
  ],

  // HVAC

  'air-conditioner-installation': [
    {
      title: 'What type of property do you have?',
      name: 'property-type',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What type of air conditioning system do you need?',
      name: 'air-conditioner-system-type',
      options: [
        { img: 'central_conditioning', value: 'Central air conditioning' },
        { img: 'mini_split', value: 'Mini split system' },
        { img: 'window_ac', value: 'Window AC unit' },
        { img: 'portable_ac', value: 'Portable AC unit' },
        { img: 'consultation', value: 'Need consultation' },
      ],
      withOther: true,
    },
    {
      title: 'Is this a new installation or a replacement?',
      name: 'installation-type',
      options: [
        { img: 'ac_installation', value: 'New installation' },
        { img: 'ac_replacement', value: 'Complete AC replacement' },
        { img: 'ac_upgrade', value: 'Partial replacement/upgrade' },
        { img: 'consultation', value: 'Need consultation' },
      ],
    },
    {
      title: 'How many zones do you need to cool?',
      name: 'zones-count',
      options: [
        { value: 'Single zone (whole house)' },
        { value: '2-3 zones' },
        { value: '4-6 zones' },
        { value: 'More than 6 zones' },
        { value: 'Not sure - need assessment' },
      ],
      isColumn: true,
      isKeepGoing: true,
    },
  ],

  'air-conditioner-maintenance': [
    {
      title: 'What type of property do you have?',
      name: 'property-type',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What type of air conditioning system do you have?',
      name: 'air-conditioner-system-type',
      options: [
        { img: 'central_conditioning', value: 'Central air conditioning' },
        { img: 'mini_split', value: 'Mini split system' },
        { img: 'window_ac', value: 'Window AC unit' },
        { img: 'portable_ac', value: 'Portable AC unit' },
        { img: 'not_sure', value: 'Not sure' },
      ],
      withOther: true,
    },
    {
      title: 'What type of maintenance service do you need?',
      subtitle: 'Multiple selection is available',
      name: 'maintenance-service-type',
      options: [
        { img: 'repairs', value: 'Regular tune-up and inspection' },
        { img: 'filter', value: 'Filter replacement' },
        { img: 'duct', value: 'Duct cleaning' },
        { img: 'coil', value: 'Coil cleaning' },
        { img: 'thermostat', value: 'Thermostat calibration' },
        { img: 'refrigerant', value: 'Refrigerant check' },
      ],
      multiple: true,
      withOther: true,
    },
    {
      title: 'Are you experiencing any performance issues?',
      name: 'performance-issues',
      options: [
        { img: 'higher_bills', value: 'Higher energy bills than usual' },
        { img: 'refrigerant', value: 'Uneven cooling' },
        { img: 'noises', value: 'Strange noises' },
        { img: 'poor', value: 'Poor air quality' },
      ],
      multiple: true,
      isKeepGoing: true,
    },
  ],

  'air-conditioner-repair': [
    {
      title: 'What type of property do you have?',
      name: 'property-type',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What type of air conditioning system needs repair?',
      name: 'ac-system-type',
      options: [
        { img: 'central_conditioning', value: 'Central air conditioning' },
        { img: 'mini_split', value: 'Mini split system' },
        { img: 'window_ac', value: 'Window AC unit' },
        { img: 'portable_ac', value: 'Portable AC unit' },
        { img: 'not_sure', value: 'Not sure' },
      ],
      withOther: true,
    },
    {
      title: 'What issues are you experiencing?',
      subtitle: 'Multiple selection is available',
      name: 'ac-issues',
      options: [
        { img: 'outlets_not', value: 'System not turning on' },
        { img: 'refrigerant', value: 'Not cooling properly' },
        { img: 'noises', value: 'Strange noises' },
        { img: 'water', value: 'Water leaking' },
        { img: 'higher_bills', value: 'High energy bills' },
        { img: 'poor', value: 'Poor air quality' },
      ],
      multiple: true,
      withOther: true,
    },
    {
      title: 'When did the problem start?',
      name: 'problem-timeline',
      options: [
        { value: 'Just started today' },
        { value: 'A few days ago' },
        { value: 'A few weeks ago' },
        { value: 'Ongoing issue' },
      ],
      isColumn: true,
      isKeepGoing: true,
    },
  ],

  'heat-pump-installation': [
    {
      title: 'What type of property do you have?',
      name: 'property-type',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What type of heat pump system do you need?',
      name: 'heat-pump-type',
      options: [
        { img: 'air', value: 'Air-source heat pump' },
        { img: 'ground', value: 'Ground-source (geothermal) heat pump' },
        { img: 'water', value: 'Water-source heat pump' },
        { img: 'mini_split_2', value: 'Mini split heat pump' },
        { img: 'dual_fuel', value: 'Dual fuel heat pump' },
        { img: 'consultation', value: 'Need consultation' },
      ],
      withOther: true,
    },
    {
      title: 'Is this a new installation or a replacement?',
      name: 'installation-type',
      options: [
        { img: 'ac_installation', value: 'New installation' },
        { img: 'ac_replacement', value: 'Complete system replacement' },
        { img: 'ac_upgrade', value: 'Partial replacement/upgrade' },
        { img: 'consultation', value: 'Need consultation' },
      ],
    },
    {
      title: 'How many zones do you need to heat/cool?',
      name: 'zones-count',
      options: [
        { value: 'Single zone (whole house)' },
        { value: '2-3 zones' },
        { value: '4-6 zones' },
        { value: 'More than 6 zones' },
        { value: 'Not sure - need assessment' },
      ],
      isColumn: true,
      isKeepGoing: true,
    },
  ],

  'heat-pump-service': [
    {
      title: 'What type of property do you have?',
      name: 'property-type',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What type of heat pump system do you have?',
      subtitle: 'Multiple selection is available',
      name: 'heat-pump-type',
      options: [
        { img: 'air', value: 'Air-source heat pump' },
        { img: 'ground', value: 'Ground-source (geothermal) heat pump' },
        { img: 'water', value: 'Water-source heat pump' },
        { img: 'mini_split_2', value: 'Mini split heat pump' },
        { img: 'dual_fuel', value: 'Dual fuel heat pump' },
        { img: 'not_sure', value: 'Not sure' },
      ],
      multiple: true,
      withOther: true,
    },
    {
      title: 'What type of service do you need?',
      subtitle: 'Multiple selection is available',
      name: 'service-type',
      options: [
        { img: 'repairs', value: 'Regular tune-up and inspection' },
        { img: 'filter', value: 'Filter replacement' },
        { img: 'duct', value: 'Duct cleaning' },
        { img: 'coil', value: 'Coil cleaning' },
        { img: 'thermostat', value: 'Thermostat calibration' },
        { img: 'refrigerant', value: 'Refrigerant check' },
        { img: 'defrost', value: 'Defrost cycle check' },
      ],
      multiple: true,
      withOther: true,
    },
    {
      title: 'Are you experiencing any performance issues?',
      name: 'performance-issues',
      options: [
        { img: 'higher_bills', value: 'Higher energy bills than usual' },
        { img: 'uneven_cooling', value: 'Uneven heating/cooling' },
        { img: 'noises', value: 'Strange noises' },
        { img: 'ice', value: 'Ice buildup on outdoor unit' },
        { img: 'poor', value: 'Poor air quality' },
      ],
      multiple: true,
      isKeepGoing: true,
    },
  ],

  'heat-pump-repair': [
    {
      title: 'What type of property do you have?',
      name: 'property-type',
      options: [
        { img: 'residential', value: 'Residential' },
        { img: 'commercial', value: 'Commercial' },
      ],
    },
    {
      title: 'What type of heat pump system needs repair?',
      name: 'heat-pump-type',
      options: [
        { img: 'air', value: 'Air-source heat pump' },
        { img: 'ground', value: 'Ground-source (geothermal) heat pump' },
        { img: 'water', value: 'Water-source heat pump' },
        { img: 'mini_split_2', value: 'Mini split heat pump' },
        { img: 'dual_fuel', value: 'Dual fuel heat pump' },
        { img: 'not_sure', value: 'Not sure' },
      ],
      withOther: true,
    },
    {
      title: 'What issues are you experiencing?',
      subtitle: 'Multiple selection is available',
      name: 'heat-pump-issues',
      options: [
        { img: 'outlets_not', value: 'System not turning on' },
        { img: 'uneven_cooling', value: 'Not heating/cooling properly' },
        { img: 'water', value: 'Water leaking' },
        { img: 'ice', value: 'Ice buildup on outdoor unit' },
        { img: 'higher_bills', value: 'High energy bills' },
        { img: 'poor', value: 'Poor air quality' },
      ],
      multiple: true,
      withOther: true,
    },
    {
      title: 'When did the problem start?',
      name: 'problem-timeline',
      options: [
        { value: 'Just started today' },
        { value: 'A few days ago' },
        { value: 'A few weeks ago' },
        { value: 'Ongoing issue' },
      ],
      isColumn: true,
      isKeepGoing: true,
    },
  ],
};
